import { DeepPartial } from '@empathybroker/ebx-gluon';
import { IdentifierSuggestionsConfig } from '@empathybroker/ebx-gluon/dist/models';

export const MOBILE_IDENTIFIER_SUGGESTIONS_CONFIG: DeepPartial<IdentifierSuggestionsConfig> = {
  size: 4
};
